import { useState, useEffect } from "react";
import "./css/style.css";

import { NavLink, Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faBars,
  faHome,
  faSearch,
  faStore,
  faUserPlus,
  faUsers,
  faRightFromBracket,
  faFileInvoice,
  faGears,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials } from "../../redux-state/features/user/userSlice";
import { useNavigate } from "react-router";

import urls from "../../urls";
const Sidebar = ({ children }) => {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(true);
  const { userName, userEmail, isAuthenticated } = useSelector(
    (state) => state.userState
  );
  const dispatch = useDispatch();
  useEffect(() => {
    console.log(userEmail);
    if (!isAuthenticated) navigate("/");
  }, [isAuthenticated]);
  const toggleSidebar = () => {
    setIsActive((prev) => !prev);
  };
  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(clearCredentials());
  };
  return (
    <>
      <div className={`sidebar ${isActive ? "active" : ""}`}>
        <div className="logo_content">
          <FontAwesomeIcon
            className=" btn border-0"
            id="btn"
            icon={faBars}
            onClick={toggleSidebar}
            size="sm"
          />
          <div className="logo">
            <i className="bx bxl-javascript"></i>
            <div className="logo_name">إدارة المخزون و الصيانة</div>
          </div>

          {/* <i className="bx bx-menu" id="btn" onClick={toggleSidebar}></i> */}
        </div>

        <ul className="nav_list">
          <li>
            <Link to={"/admin"}>
              {/* <i className="bx bx-cart-alt"></i> */}
              <FontAwesomeIcon className="mx-2" icon={faHome} size="lg" />
              <span className="links_name">الصفحة الرئيسية </span>
            </Link>
            {/* <span className="tooltip">الرئيسية </span> */}
          </li>
          <li>
            <Link to={"accounts"}>
              <FontAwesomeIcon className="mx-2" icon={faUsers} size="lg" />
              <span className="links_name"> حسابات المستخدمين </span>
            </Link>
            {/* <span className="tooltip"> حسابات المستخدمين </span> */}
          </li>
          <li>
            <Link to={"store"}>
              <FontAwesomeIcon className="mx-2" icon={faStore} size="lg" />
              <span className="links_name">إدارة المخزن </span>
            </Link>
          </li>

          <li>
            <Link to={"invoice"}>
              <FontAwesomeIcon
                className="mx-2"
                icon={faFileInvoice}
                size="lg"
              />
              <span className="links_name">التوريد</span>
            </Link>
          </li>
          <li>
            <Link to={"inventory"}>
              <FontAwesomeIcon className="mx-2" icon={faBarcode} size="lg" />
              <span className="links_name">جرد العتاد </span>
            </Link>
          </li>
          <li>
            <Link to={"settings"}>
              <FontAwesomeIcon className="mx-2" icon={faGears} size="lg" />
              <span className="links_name"> الإعدادات </span>
            </Link>
          </li>
          <li>
            <a href="#" onClick={logOut}>
              <FontAwesomeIcon
                className="mx-2"
                icon={faRightFromBracket}
                size="lg"
              />
              <span className="links_name">تسجيل الخروج </span>
            </a>
          </li>
        </ul>
        {userEmail === "soufyanebouguetaia48@gmail.com" && (
          <div className="profile_content">
            <div className="profile">
              <div className="profile_details">
                <img src={urls.uploads("soufian.jpg")} alt="" />
                <div className="name_job">
                  <div className="name">د. سفيان بوقطاية</div>
                  <div className="job text-center">عميد الكلية</div>
                </div>
              </div>
              <i className="bx bx-log-out" id="log_out"></i>
            </div>
          </div>
        )}
      </div>
      <div className="home_content">
        <div className="text scrollable-div">{children}</div>
      </div>
    </>
  );
};

export default Sidebar;
